module.exports = __webpack_public_path__ + "img/cent.b6ccb28f.svg";